import Modal from "bootstrap/js/dist/modal";

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        document.getElementById("modalImage").src = fullImg;
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
//The hidden items carry their thumbnail URL on the anchor (data-gallery-src) and hold no <img>,
//so image-optimizer plugins have nothing to rewrite. The fallbacks below cover markup produced by
//the older template, which may still be sitting in a plugin's HTML cache: such an <img> has had its
//data-src consumed and re-published under a plugin-private name.
const GALLERY_SRC_ATTRS = ["data-src", "data-wpc-qw-src", "data-wpc-fb", "data-lazy-src"];

function galleryThumbUrl(hiddenItem) {
    const own = hiddenItem.getAttribute("data-gallery-src");
    if (own) {
        return own;
    }
    const img = hiddenItem.querySelector("img");
    if (!img) {
        return null;
    }
    for (const attr of GALLERY_SRC_ATTRS) {
        const value = img.getAttribute(attr);
        if (value) {
            return value;
        }
    }
    //a real src that is not a placeholder is already usable
    const src = img.getAttribute("src");
    return src && src.indexOf("data:") !== 0 ? src : null;
}

document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems.length) {
            return;
        }
        let revealed = 0;
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem) => {
            const thumbUrl = galleryThumbUrl(hiddenItem);
            if (!thumbUrl) {
                return;
            }
            //build the image if the item does not already carry one
            let img = hiddenItem.querySelector("img");
            if (!img) {
                img = document.createElement("img");
                img.alt = "Gallery Image";
                hiddenItem.appendChild(img);
            }
            img.src = thumbUrl;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
            revealed += 1;
        });
        //only retire the button if it actually did something: a silent failure here reads as a
        //caching bug, a button that stays put reads as the bug it is
        if (revealed) {
            item.remove();
        }
    });
});

// FAQ accordion
document.querySelectorAll(".accordion .accordion-button").forEach((button) => {
    button.addEventListener("click", () => {
        const accordion = button.closest(".accordion");
        if (!accordion) {
            return;
        }

        accordion.classList.toggle("active");
    });
});

// Service areas accordion
var acc = document.querySelectorAll(".service-area-inner button.accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //stop propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//when the mobile menu is shown, check the position
let navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        //get the .header-inner element
        let headerInner = document.querySelector(
            "#wrapper-navbar .header-inner",
        );
        if (!headerInner) {
            return;
        }

        //get the vertical position of the button relative to the window
        let pozY = navbarToggler.getBoundingClientRect().top;

        if (!pozY) {
            return;
        }

        if (pozY < 30) {
            //add class .scrolling to the .header-inner element
            headerInner.classList.add("scrolling");
        } else {
            //remove class .scrolling from the .header-inner element
            headerInner.classList.remove("scrolling");
        }
    });
}

// Home hero — collapse the ISA-arborist copy on phones so the call button stays
// on the first screen. Collapsed height tracks the badge, so the two line up.
(function () {
    const text = document.querySelector("#home-hero .hero-arborist-text");
    if (!text) {
        return;
    }

    const copy = text.querySelector(".hero-arborist-copy");
    const toggle = text.querySelector(".hero-arborist-toggle");
    const label = text.querySelector(".hero-arborist-toggle-label");
    const logo = document.querySelector("#home-hero .hero-arborist-logo-wrap");
    if (!copy || !toggle || !label) {
        return;
    }

    // Matches @include media-breakpoint-down(sm) in _home.scss.
    const mq = window.matchMedia("(max-width: 575.98px)");
    let expanded = false;

    function collapsedHeight() {
        return logo ? Math.round(logo.getBoundingClientRect().height) : 157;
    }

    function apply() {
        if (!mq.matches) {
            copy.classList.remove("is-collapsed");
            copy.style.removeProperty("--hero-arborist-collapsed");
            toggle.hidden = true;
            return;
        }

        toggle.hidden = false;
        copy.style.setProperty("--hero-arborist-collapsed", collapsedHeight() + "px");
        copy.classList.toggle("is-collapsed", !expanded);
        toggle.setAttribute("aria-expanded", String(expanded));
        label.textContent = expanded ? "Show less" : "Read more";
    }

    function setExpanded(next) {
        expanded = next;
        apply();
    }

    toggle.addEventListener("click", () => setExpanded(!expanded));

    // Pointer convenience only — tapping the copy expands it. Deliberately not
    // exposed as a role="button"/tabindex control: the accessible name would be
    // the whole paragraph. The toggle below is the keyboard/AT control.
    copy.addEventListener("click", () => {
        if (mq.matches && !expanded) {
            setExpanded(true);
        }
    });

    mq.addEventListener("change", apply);
    // The badge is sized from its aspect ratio, but re-measure on resize/load anyway.
    window.addEventListener("resize", apply);
    window.addEventListener("load", apply);

    apply();
})();

// About Instagram marquee — the tiles are moved into view by a CSS transform
// inside an overflow:hidden track, and native lazy loading does not re-run its
// viewport check for that, so most tiles stayed blank until a hover forced a
// repaint. Load the whole strip once the section approaches the viewport.
(function () {
    const section = document.getElementById("about-instagram");
    if (!section) {
        return;
    }

    const images = section.querySelectorAll('.ig-tile img[loading="lazy"]');
    if (!images.length) {
        return;
    }

    function loadAll() {
        images.forEach((img) => {
            // Switching the attribute back to eager resumes a deferred load.
            img.loading = "eager";
        });
    }

    if (!("IntersectionObserver" in window)) {
        loadAll();
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
                return;
            }
            loadAll();
            observer.disconnect();
        },
        // start fetching before the section is on screen, so tiles are ready
        // by the time they cycle through the visible window
        { rootMargin: "600px 0px" },
    );

    observer.observe(section);
})();
